import { render, staticRenderFns } from "./stop_list.vue?vue&type=template&id=16bdc941&scoped=true&"
import script from "./stop_list.vue?vue&type=script&lang=js&"
export * from "./stop_list.vue?vue&type=script&lang=js&"
import style0 from "./stop_list.vue?vue&type=style&index=0&id=16bdc941&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bdc941",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16bdc941')) {
      api.createRecord('16bdc941', component.options)
    } else {
      api.reload('16bdc941', component.options)
    }
    module.hot.accept("./stop_list.vue?vue&type=template&id=16bdc941&scoped=true&", function () {
      api.rerender('16bdc941', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/stop/stop_list.vue"
export default component.exports